import { useRouter } from 'next/router'
import Notice from 'components/Notice'

type Args = {
  title: string
  message: string
  type: 'warn' | 'error' | 'success'
}

export const flashUrl = ({ title, message, type }: Args) =>
  `flashTitle=${encodeURIComponent(
    title
  )}&flashMessage=${message}&flashType=${type}`

type Props = {
  className: string
}

export default function Flash({ className }: Props) {
  const router = useRouter()
  const { flashTitle, flashMessage, flashType } = router.query as {
    flashTitle: string
    flashMessage: string
    flashType: Args['type']
  }
  if (!flashType) return null

  return (
    <Notice
      className={className}
      message={flashMessage}
      title={flashTitle}
      type={flashType}
    />
  )
}
